
import { Component, Vue, Watch } from 'vue-property-decorator'
import Wizard from '@/components/wizard/Wizard.vue'
import IWizard from '@/components/wizard/IWizard'
import { ApplicationModule, WizardModule } from '@/store'

	@Component({
	  name: 'AppFormView',
	  components: {
	    Wizard
	  }
	})
export default class AppFormView extends Vue {
  // #region Data

		loanApp = ApplicationModule.form;

		// #endregion

		// #region Computed

		get steps () {
		  return WizardModule.steps
		}

		async mounted () {
		  setTimeout(() => {
		    if (ApplicationModule.isPrePopped) {
		      const wizard = (this.$refs.wizard as unknown) as IWizard

		      wizard.goToPage(9)

		      window.location.hash = 'Summary'
		    }
		  }, 100)
		}

		get isLoaded () {
		  return ApplicationModule.isLoaded
		}

		get isPrePopped () {
		  return ApplicationModule.isPrePopped
		}

		// #endregion

		// #region Watches

		@Watch('isLoaded')
		showApp () {
		  this.loanApp = ApplicationModule.form
		}

		@Watch('isPrePopped')
		check () {
		  const wizard = (this.$refs.wizard as unknown) as IWizard

		  wizard.goToPage(9)
		}

		@Watch('loanApp', { deep: true, immediate: true })
		commitAppToStore () {
		  ApplicationModule.updateForm(this.loanApp)
		}

		@Watch('steps', { deep: true, immediate: true })
		commitStepsToStore () {
		  WizardModule.updateWizardSteps(this.steps)
		}

  // #endregion
}
